









import { Component, Prop, Vue } from 'vue-property-decorator';
import { Button } from '@/pages/profile/components';

@Component({
  components: {
    Button,
  },
})
export default class Sucsess extends Vue {
  @Prop({ type: String, default: '' })
  readonly text!: string;

  @Prop({ type: String, default: 'Все понятно' })
  readonly btnText!: string;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/certificate/components/sucsess/Sucsess.vue